export const REFERRALS = {
  REFERRAL_LENGTH_DAYS: '30',
};
